/* MAISON D'VUE - Release 2 behaviour: global header menu, live cart count,
 * size picker, hair-chapter tabs and community video cards.
 * Ported from the handoff's app.js. Every block checks that its markup exists,
 * because the header (and so this file) is loaded on every page of the store. */
(function () {
  'use strict';
  if (window.__mdvxLoaded) return;
  window.__mdvxLoaded = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---- Mobile navigation ------------------------------------------------ */
  function initMenu() {
    var menu = document.querySelector('.mdvx header .menu');
    var nav = document.querySelector('.mdvx header .mobile-nav');
    if (!menu || !nav) return;

    function setOpen(open) {
      nav.hidden = !open;
      menu.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      menu.textContent = open ? '×' : '☰';
    }
    menu.addEventListener('click', function () { setOpen(nav.hidden); });
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !nav.hidden) { setOpen(false); menu.focus(); }
    });
  }

  /* ---- Bag count: always the real cart ---------------------------------- */
  function initCartCount() {
    var badge = document.querySelector('[data-mdvx-cart-count]');
    if (!badge) return;
    var link = badge.closest('a');

    function paint(count) {
      badge.textContent = String(count);
      badge.hidden = !(count > 0);
      if (link) link.setAttribute('aria-label', count > 0 ? 'Bag, ' + count + ' item' + (count === 1 ? '' : 's') : 'Bag');
    }
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart && typeof cart.item_count === 'number') paint(cart.item_count); })
        .catch(function () { /* the server-rendered count stays */ });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  /* ---- Size picker: 30 ml / 10 ml --------------------------------------- */
  function initSizePicker() {
    var buttons = document.querySelectorAll('.mdvx .size-picker .size');
    var cta = document.querySelector('.mdvx [data-size-cta]');
    if (!buttons.length || !cta) return;
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.toggle('active', b === button);
          b.setAttribute('aria-pressed', String(b === button));
        });
        cta.innerHTML = (button.dataset.label || 'EXPLORE') + ' <span>↗</span>';
        if (button.dataset.url) cta.href = button.dataset.url;
        // Masiela (Oct 31, 10:27): tapping a bottle takes the shopper straight to that product page (no extra "explore" step)
        if (button.dataset.url) window.location.href = button.dataset.url;
      });
    });
  }

  /* ---- Quick add: little bag on the bottle photograph opens a sheet with "Add to bag" ---- */
  function initQuickAdd() {
    var sheet = document.querySelector('[data-quick-sheet]');
    var opener = document.querySelector('[data-quick-open]');
    if (!sheet || !opener) return;
    var items = [].slice.call(sheet.querySelectorAll('[data-quick-item]'));
    var sizes = [].slice.call(sheet.querySelectorAll('[data-quick-size]'));
    var addBtn = sheet.querySelector('[data-quick-add]');
    var priceEl = sheet.querySelector('[data-quick-add-price]');
    var labelEl = sheet.querySelector('[data-quick-add-label]');
    var note = sheet.querySelector('[data-quick-note]');
    var current = 0, busy = false;

    function show(i) {
      current = i;
      items.forEach(function (it, n) { it.hidden = n !== i; });
      sizes.forEach(function (b, n) { b.classList.toggle('active', n === i); b.setAttribute('aria-pressed', String(n === i)); });
      var it = items[i];
      var price = it.querySelector('.quick-price');
      priceEl.textContent = price ? price.textContent : '';
      var ok = it.getAttribute('data-available') !== 'false';
      addBtn.disabled = !ok;
      labelEl.textContent = ok ? 'Add to bag' : 'Sold out';
      note.textContent = '';
    }
    function open() {
      // Shopify's "Draft" preview bar (staging only) sits over the bottom of the screen: leave room for it so the button stays visible
      sheet.style.setProperty('--qa-bottom', document.getElementById('PBarNextFrame') ? '64px' : '0px');
      sheet.hidden = false;
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
      document.documentElement.classList.add('mdvx-quick-lock');
      show(current);
      addBtn.focus({ preventScroll: true });
    }
    function close() {
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('mdvx-quick-lock');
      setTimeout(function () { sheet.hidden = true; }, 280);
      opener.focus({ preventScroll: true });
    }
    opener.addEventListener('click', open);
    sheet.querySelectorAll('[data-quick-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });
    sizes.forEach(function (b) { b.addEventListener('click', function () { show(+b.getAttribute('data-quick-size')); }); });
    addBtn.addEventListener('click', function () {
      if (busy || addBtn.disabled) return;
      busy = true; labelEl.textContent = 'Adding…'; note.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +items[current].getAttribute('data-variant'), quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          busy = false;
          if (!res.ok) { labelEl.textContent = 'Add to bag'; note.textContent = (res.body && (res.body.description || res.body.message)) || 'Sorry, that could not be added. Please try again.'; return; }
          labelEl.textContent = 'Added ✓';
          note.innerHTML = '<a href="/cart">View bag</a>';
          fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
            var badge = document.querySelector('[data-mdvx-cart-count]');
            if (badge && typeof cart.item_count === 'number') { badge.textContent = String(cart.item_count); badge.hidden = !(cart.item_count > 0); }
          }).catch(function () {});
          setTimeout(function () { if (!sheet.hidden) labelEl.textContent = 'Add to bag'; }, 2400);
        })
        .catch(function () { busy = false; labelEl.textContent = 'Add to bag'; note.textContent = 'Sorry, that could not be added. Please try again.'; });
    });
  }

  /* ---- Pinned Add to Bag on the homepage: shows once the shopper has scrolled past the top, opens the size sheet ---- */
  function initPinnedBuy() {
    var bar = document.querySelector('[data-pinned]');
    var add = document.querySelector('[data-pinned-add]');
    var opener = document.querySelector('[data-quick-open]');
    if (!bar || !add || !opener) return;
    bar.hidden = false;
    document.body.classList.add('has-mdvx-pinned');
    add.addEventListener('click', function () { opener.click(); });
    var ticking = false;
    function place() {
      ticking = false;
      var sheetOpen = document.documentElement.classList.contains('mdvx-quick-lock');
      bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.8 && !sheetOpen);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(place); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    new MutationObserver(onScroll).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    place();
  }

  /* ---- Hair chapters: accessible tabs ----------------------------------- */
  function initChapterTabs() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.mdvx [data-panel]'));
    if (!tabs.length) return;
    function activate(button) {
      tabs.forEach(function (b) {
        var active = b === button;
        b.setAttribute('aria-selected', String(active));
        b.tabIndex = active ? 0 : -1;
        var panel = document.getElementById(b.dataset.panel);
        if (panel) panel.hidden = !active;
      });
    }
    tabs.forEach(function (button, i) {
      button.addEventListener('click', function () { activate(button); });
      button.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          activate(tabs[next]);
          tabs[next].focus();
        }
      });
    });
  }

  /* ---- Community videos: one plays at a time ---------------------------- */
  function initVideoCards() {
    var videos = document.querySelectorAll('.mdvx video');
    videos.forEach(function (video) {
      video.addEventListener('play', function () {
        videos.forEach(function (other) { if (other !== video) other.pause(); });
      });
    });
    document.querySelectorAll('.mdvx .ugc-card').forEach(function (card) {
      var video = card.querySelector('video');
      var button = card.querySelector('.ugc-watch');
      if (!video || !button) return;
      button.addEventListener('click', function () {
        video.controls = true;
        var started = video.play();
        if (started && started.catch) started.catch(function () { video.controls = false; card.classList.remove('playing'); });
      });
      video.addEventListener('play', function () { card.classList.add('playing'); });
      video.addEventListener('pause', function () { card.classList.remove('playing'); video.controls = false; });
      video.addEventListener('ended', function () { card.classList.remove('playing'); video.controls = false; });
    });
  }


  /* ---- Judge.me excerpts: show only what is still published -------------- */
  /* Every written excerpt is rendered hidden with its Judge.me review ID. The
   * Hair Elixir product page carries Judge.me's live, server-rendered review
   * list, so an excerpt is revealed only while its ID is still in that list.
   * A deleted or unpublished review therefore disappears by itself, and if the
   * check cannot run, nothing is shown (never a substitute). The ID list is
   * cached for the session so the product page is not fetched on every view. */
  var JM_CACHE_KEY = 'mdvx-judgeme-ids-v1';
  var JM_CACHE_MS = 15 * 60 * 1000;

  function liveReviewIds(pdpUrl) {
    try {
      var cached = JSON.parse(sessionStorage.getItem(JM_CACHE_KEY) || 'null');
      if (cached && cached.url === pdpUrl && Date.now() - cached.at < JM_CACHE_MS) return Promise.resolve(cached.ids);
    } catch (e) { /* storage unavailable: fall through to the network */ }
    return fetch(pdpUrl, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('product page ' + r.status); return r.text(); })
      .then(function (html) {
        var ids = [], re = /data-review-id=['"]([0-9a-f-]{36})['"]/g, m;
        while ((m = re.exec(html))) { if (ids.indexOf(m[1]) === -1) ids.push(m[1]); }
        if (!ids.length) throw new Error('no Judge.me reviews found');
        try { sessionStorage.setItem(JM_CACHE_KEY, JSON.stringify({ url: pdpUrl, at: Date.now(), ids: ids })); } catch (e) { /* ignore */ }
        return ids;
      });
  }

  function initReviewExcerpts() {
    var nodes = document.querySelectorAll('.mdvx [data-judgeme-review-id]');
    if (!nodes.length) return;
    var holder = document.querySelector('[data-mdvx-pdp]');
    var pdpUrl = (holder && holder.getAttribute('data-mdvx-pdp')) || '/products/hair-elixir';
    liveReviewIds(pdpUrl).then(function (ids) {
      nodes.forEach(function (node) {
        if (ids.indexOf(node.getAttribute('data-judgeme-review-id')) !== -1) node.hidden = false;
      });
      document.querySelectorAll('.mdvx [data-reveal-when-any]').forEach(function (wrap) {
        wrap.hidden = !wrap.querySelector('[data-judgeme-review-id]:not([hidden])');
      });
    }).catch(function () { /* leave every excerpt hidden */ });
  }


  /* ---- Typography: never leave a single word alone on the last line ------- */
  /* Client request (Oct 31). For every running-text block in the page content, the last two words are
   * joined with a non-breaking space, so a paragraph or heading can never end on a lone word. The text
   * itself does not change. Customer reviews are skipped (quoted verbatim), as are links, buttons, menus
   * and anything that is a grid or flex row rather than running text. */
  var TYPO_TAGS = { P: 1, LI: 1, H1: 1, H2: 1, H3: 1, H4: 1, H5: 1, H6: 1, BLOCKQUOTE: 1, FIGCAPTION: 1, DD: 1, DT: 1, DIV: 1, SUMMARY: 1 };
  var TYPO_BLOCK = { DIV: 1, P: 1, UL: 1, OL: 1, LI: 1, H1: 1, H2: 1, H3: 1, H4: 1, H5: 1, H6: 1, SECTION: 1, ARTICLE: 1, BLOCKQUOTE: 1, FIGURE: 1, TABLE: 1, DETAILS: 1, HR: 1, FORM: 1, ASIDE: 1, HEADER: 1, FOOTER: 1, NAV: 1, MAIN: 1, DL: 1, DD: 1, DT: 1, PRE: 1, SUMMARY: 1, FIGCAPTION: 1 };
  var TYPO_SYMBOLS = /^[\s*+×↗↑↓→–—·]+$/;
  var NBSP = ' ';

  function typoTextNodes(el) {
    var out = [], walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = walker.nextNode())) {
      if (!n.nodeValue.trim() || TYPO_SYMBOLS.test(n.nodeValue)) continue;
      if (n.parentElement && n.parentElement.closest('[aria-hidden="true"],script,style,sup')) continue;
      out.push(n);
    }
    return out;
  }

  // Width of the last two words as laid out now (they must not be wider than the box they sit in).
  function pairFits(el, startNode, startIdx, endNode, endIdx) {
    try {
      var r = document.createRange();
      r.setStart(startNode, startIdx);
      r.setEnd(endNode, endIdx);
      var w = r.getBoundingClientRect().width;
      var box = el.getBoundingClientRect().width;
      return !w || !box || w <= box * 0.9;
    } catch (e) { return true; }
  }

  function bindLastWords(el) {
    var nodes = typoTextNodes(el);
    if (!nodes.length) return;
    var last = nodes[nodes.length - 1];
    var before = last.nodeValue;
    var inner = /(\S)\s+(\S+\s*)$/.exec(before);
    if (inner) {
      var startIdx = before.search(/\S+\s+\S+\s*$/);
      var tail = before.slice(startIdx).replace(/\s+$/, '');
      if (tail.length > 40) return;                    // absurdly long pair: let it wrap (the width check below does the real work)
      last.nodeValue = before.replace(/(\S)\s+(\S+\s*)$/, '$1' + NBSP + '$2');
      if (!pairFits(el, last, startIdx, last, startIdx + tail.length)) last.nodeValue = before;   // too wide for the box: undo
      return;
    }
    // the last word is alone in its text node (e.g. inside <em>): join it to the word before it
    if (nodes.length < 2) return;
    var prev = nodes[nodes.length - 2];
    var br = el.querySelectorAll('br');
    for (var i = 0; i < br.length; i++) {              // never join across a deliberate line break
      if ((prev.compareDocumentPosition(br[i]) & 4) && (br[i].compareDocumentPosition(last) & 4)) return;
    }
    var prevBefore = prev.nodeValue;
    if (/\s$/.test(prevBefore)) {
      var ws = prevBefore.search(/\S+\s+$/);
      prev.nodeValue = prevBefore.replace(/\s+$/, NBSP);
      var lastWord = last.nodeValue.replace(/\s+$/, '');
      if (ws < 0 || !pairFits(el, prev, ws, last, lastWord.length)) prev.nodeValue = prevBefore;
    } else if (/^\s/.test(last.nodeValue)) {
      last.nodeValue = last.nodeValue.replace(/^\s+/, NBSP);
    }
  }

  function initTypography() {
    var scopes = [document.getElementById('MainContent')].concat([].slice.call(document.querySelectorAll('footer')));
    scopes.forEach(function (scope) {
      if (!scope) return;
      var all = scope.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (!TYPO_TAGS[el.tagName]) continue;
        if (el.closest('a,button,nav,[data-mdvp-reviews],.jdgm-widget,[data-no-widow]')) continue;
        var kids = el.children, leaf = true;
        for (var k = 0; k < kids.length; k++) { if (TYPO_BLOCK[kids[k].tagName]) { leaf = false; break; } }
        if (!leaf) continue;
        if ((el.textContent.trim().split(/\s+/).length) < 4) continue;
        var d = getComputedStyle(el).display;
        if (d === 'flex' || d === 'grid' || d === 'inline-flex' || d === 'inline-grid' || d === 'table') continue;
        if (getComputedStyle(el).whiteSpace === 'nowrap') continue;
        bindLastWords(el);
      }
    });
  }

  ready(function () {
    initMenu();
    initCartCount();
    initSizePicker();
    initQuickAdd();
    initPinnedBuy();
    initChapterTabs();
    initVideoCards();
    initReviewExcerpts();
    initTypography();
  });
})();
